/* eslint-disable no-console */
import React from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../../../../Common/Svgs/CloseIcon";
import TimeoffCard from "../Common/TimeoffCard";
// import { TIME_OFF_STATUS } from "../Common/constants";
import { client } from "../../../../../../Utils/axiosClient";
import { updateUsers } from "../../../../../../Redux/Slices/users.slice";

const TimeoffModal = ({ visible, onCancel, onSuccess }) => {
  const { timeoffModal } = useSelector((state) => state.users);
  const dispatch = useDispatch();

  const handleReject = async (timeoffId) => {
    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/drivers/reject-timeoff`,
        {
          id: timeoffId,
        },
      );
      await onSuccess();
    } catch (e) {
      console.log("Error rejecting timeoff: ", e);
    }

    onCancel();
  };

  const handleApprove = async (timeoff) => {
    const trips = timeoffModal?.timeoff?.tripsCount || 0;
    const sessions = timeoffModal?.timeoff?.sessionsCount || 0;

    const hasConflict = trips > 0 || sessions > 0;

    if (hasConflict) {
      dispatch(
        updateUsers({
          key: "transferTimeoffModal",
          value: {
            visible: true,
            timeoffId: timeoff?.id,
            driverId: timeoffModal?.driver?.id,
            trips,
            sessions,
          },
        }),
      );

      onCancel();
      return;
    }

    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/drivers/approve-timeoff`,
        {
          id: timeoff?.id,
        },
      );
      await onSuccess();
    } catch (e) {
      console.log("Error rejecting timeoff: ", e);
    }
    onCancel();
  };

  console.log({ timeoffModal });

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="460px">
      <div
        className="p-6"
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-start justify-between pb-4 border-b border-light-grey">
          <div>
            <p className="font-poppins font-medium text-base leading-[100%] capitalize">
              {timeoffModal?.driver?.name}
            </p>

            <p className="mt-1 font-aileron font-normal text-xs leading-[100%] text-dark-gray">
              {timeoffModal?.timeoff?.startDate
                ? dayjs(timeoffModal?.timeoff?.startDate).format("DD MMM YYYY")
                : ""}
            </p>
          </div>

          <button type="button" onClick={onCancel}>
            <CloseIcon className="stroke-dark-gray w-6 h-6" />
          </button>
        </div>

        <div className="mt-4">
          <TimeoffCard
            hideName
            item={timeoffModal?.timeoff}
            handleReject={handleReject}
            handleApprove={handleApprove}
            tripsCount={timeoffModal?.timeoff?.trips?.length}
            sessionsCount={timeoffModal?.timeoff?.sessions?.length}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default TimeoffModal;
